/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Node_ImsInputs */

const en_node_ims = /** @type {(inputs: Node_ImsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMS`)
};

/**
* | output |
* | --- |
* | "IMS" |
*
* @param {Node_ImsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const node_ims = /** @type {((inputs?: Node_ImsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Node_ImsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_node_ims(inputs)
});